import React, { useEffect, useState } from "react";
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import { InputText } from "../../../../components/inputText/InputText";
import { DropDown } from "../../../../components/dropDown/DropDown";
import { LabelBox } from "../../../../components/labelBox/LabelBox";
import { AddClient } from "../addClient/AddClient";

import './EditClient.css';
import { GenderType, IClient, IClientData, IClientFormData } from "../../../../types/dashboard";

export const EditClient = AddClient;

interface IEditClientProps{
    client: IClientData;
    onClose: ()=>void;
    onDelete: (id: string)=>void;
    onSave: (data: IClientFormData)=>void;
    onSaveDraft: ()=>void;
}

export const EditClientOld = ({onClose, onSave, onDelete, client}: IEditClientProps)=>{
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState<GenderType>('other');
    const [notes, setNotes] = useState('');
    const [scheduleDay, setScheduleDay] = useState(-1);
    console.log(client);
    const handleAdd = ()=>{
        const newClientData = {
            firstName, 
            lastName,
            gender,
            email,
            dateOfBirth,
            notes,
            scheduleDay,
            id: client.id
        };
        onSave(newClientData);
    }

    useEffect(()=>{
        setFirstName(client.firstName || client.name.split(' ')[0]);
        setLastName(client.name.split(' ')[1]);
        setGender(client.gender || 'other');
        setEmail(client.email || '');
        setDateOfBirth(client.dateOfBirth || '');
        setNotes(client.notes || '');
        setScheduleDay(client.scheduleDay || -1);
    }, [client]);

    return <div className="scroll editClient">
        <div className="editClient_title">
            Edit client {client.name}
        </div>
        <div className="editClient_head_text">
            We need to know more about you before starting treatment. This information will help us understand you and your situation.
        </div>
        <div className="editClient_form">
            <InputText className="editClient_firstName" label="First name" value={firstName} onChange={(e)=>{setFirstName(e)}}></InputText>
            <InputText className="editClient_lastName" label="Last name" value={lastName} onChange={(e)=>{setLastName(e)}}></InputText>
            <InputText className="editClient_dateOfBirth" label="Date of birth" value={dateOfBirth} onChange={(e)=>{setDateOfBirth(e)}}></InputText>
            <InputText className="editClient_email" label="Email" value={email} onChange={(e)=>{setEmail(e)}}></InputText>
            <LabelBox label="Day">
                <DropDown values={['qwe', 'fgdh']} selectedIndex={0} onSelect={()=>{}}></DropDown>  
            </LabelBox>
            <LabelBox label="Month">
                <DropDown values={['qwe', 'fgdh']} selectedIndex={0} onSelect={()=>{}}></DropDown>  
            </LabelBox>
            <LabelBox label="Year">
                <DropDown values={['qwe', 'fgdh']} selectedIndex={0} onSelect={()=>{}}></DropDown>  
            </LabelBox>

            <div className="editClient_schedule">
                <div className="editClient_schedule_label"></div>
                <div className="editClient_schedule_content">
                    <Checkbox label="Female" checked={gender=='female'} onCheck={()=>{setGender((last)=> last == 'female' ? 'other': 'female')}}></Checkbox>
                    <Checkbox label="Male" checked={gender=='male'} onCheck={()=>{setGender((last)=> last == 'male' ? 'other': 'male')}}></Checkbox>
                </div>
            </div>
            <InputText className="editClient_notes" label="Notes" value={notes} onChange={(e)=>{setNotes(e)}}></InputText>
            <div className="editClient_schedule">
                <div className="editClient_schedule_label">Schedule</div>
                <div className="editClient_schedule_content">
                    {days.map((it, i)=><Checkbox label={it} checked={scheduleDay == i} onCheck={()=>{setScheduleDay((last)=>last == i ? -1 : i)}}></Checkbox>)}
                </div>
            </div>
            <div className="editClient_buttons">
                <div className="button saveButton editClient_submit" onClick={()=>onDelete(client.id)}>
                    Delete
                </div>
                <div className="button saveButton editClient_submit" onClick={onClose}>
                    Cancel
                </div>
                <div className="button saveButton editClient_submit" onClick={handleAdd}>
                    Save
                </div>
            </div>
        </div>
    </div>
}
